import SimpleCrudForm from "../../components/crud/SimpleCrudForm";

export default function CouponForm() {
  return (
    <SimpleCrudForm
      title="Coupon"
      apiPath="/coupons"
      listRoute="/coupons"
      initialData={{
        code: "",
        name: "",
        description: "",
        discountAmount: 5,
        minFare: 200,
        maxUses: null,
        fromDate: null,
        toDate: null,
        status: true,
      }}
      fields={[
        { name: "code", label: "Code", required: true, placeholder: "e.g. SAVE5" },
        { name: "name", label: "Name", required: true },
        { name: "description", label: "Description", type: "textarea" },
        { name: "discountAmount", label: "Discount (£)", type: "number", required: true },
        { name: "minFare", label: "Minimum fare (£)", type: "number", required: true },
        { name: "maxUses", label: "Max uses (blank = unlimited)", type: "number" },
        { name: "fromDate", label: "From date", type: "date" },
        { name: "toDate", label: "To date", type: "date" },
        { name: "status", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
